import { getMetricsApiPrefix } from '../config/EnvData';
import styled from "styled-components";
import React, { useState,useEffect} from "react";
import axios from 'axios';
import Plot from 'react-plotly.js';
import {Link} from "react-router-dom";

import {alpha, Box } from '@mui/system';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
const SummaryBoxDiv = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    min-width:180px;
    min-height:180px;
    margin-bottom: 10px;
    margin-left: 10px;
    cursor: pointer;
    background-color: ${(props) => props.color};
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    text-decoration: none; /* prevents underline */
    color: inherit;        /* optional: ensures text color isn't link blue */

    /* You may want this too, to override child links */
    * {
      text-decoration: none;
    }
    &:hover {
        cursor: pointer;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.05) 0px 10px 10px;
    }
`;

const DetailedSummaryOverlayDivStyle = styled.div`
  position: fixed;
  text-align:center;
  justify:center;
  display:block;
  flex: none;
  top:0;
  bottom:0;
  left:0;
  right:0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5); 
  z-index: 17; 
  cursor: pointer;
`;

const OverlayPlotDivStyle = styled.div`
  display:flex;
  flex:none;
  padding-top:2%;
  justify-content: center;
  align-items: center;
  height:100%;
`;

const AirportNameStyle = styled.div`
    max-height:100px;
    margin-top:10px;
    text-align:center;
    font-size:20px;
    font-weight:bold;
    color:#275AA6;
    -webkit-user-select: none; 
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;

const DataBlockDiv = styled.div`
    text-align:left;
    margin-left:10px;
    margin-right:10px;
    font-size:12px;
    display: inline-block;
    
`;

const SelectedEpochDiv = styled.div`
    margin-bottom:5px;
    font-style: italic;
    text-align:right;
    margin-right:5px;
    font-size:10px;
    color:#275AA6;
`;

// #fafbfc;

const apiPrefix = getMetricsApiPrefix()

const GREEN  = "#e6ffe6"
const ORANGE = "#ffe0cc"
const RED    = "#ffcccc"

const epochMarkerLineColor =  '#dfdfdf'

const SummaryBox=({latestEpochFlag,selectedEpoch,selectedEpochString,airport,metroplex,displayEpochString,setTitle,
                  setActiveAirport,setActiveMetric,setMetricSelectedIndex,summaryMetricIndex,metricLookBackHorizonDays,
                  coloringThresholds,backendApiPrefix})=>{
    const [queryIterTime,setQueryIterTime] = useState(new Date())
    const [metricStartTime,setMetricStartTime] = useState(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))

    const [renderedEpochString, setRenderedEpochString] = useState(null)

    const [metroplexEncroachmentDataAll, setMetroplexEncroachmentDataAll] = useState({epochString:[],encrDur:{Total:[],Adjusted:[]}}); 
    const [centerlineDeviationDataAll, setCenterlineDeviationDataAll] = useState({epochString:[],meanCenterlineDeviation_mean:[]}); 
    const [goAroundCountDataAll, setGoAroundCountDataAll] = useState({epochString:[],goAround15min:[],holdingPattern15min:[]}); 

    
    const [dataLoadedFlag,setDataLoadedFlag] = useState(false)
    const [metroplexEncroachmentDataSelected, setMetroplexEncroachmentDataSelected] = useState({}); 
    const [adjustedMetroplexEncroachmentDataSelected, setAdjustedMetroplexEncroachmentDataSelected] = useState({}); 
    const [centerlineDeviationDataSelected, setCenterlineDeviationDataSelected] = useState({}); 
    const [goAroundCountDataSelected, setGoAroundCountDataSelected] = useState({}); 
    const [statusColor, setStatusColor] = useState(GREEN)
    const [queryChunkHours,setQueryChunkHours] = useState(0.5)
    var plotRangeStartLatest = new Date(selectedEpoch)
    var plotRangeEndLatest = new Date(selectedEpoch)
    plotRangeStartLatest.setHours(plotRangeStartLatest.getHours()-3)
    plotRangeEndLatest.setHours(plotRangeEndLatest.getHours()+2)

    const [plotRangeStart,setPlotRangeStart] = useState(plotRangeStartLatest)
    const [plotRangeEnd,setPlotRangeEnd] = useState(plotRangeEndLatest)
    var epMinusHour = new Date(selectedEpoch)
    epMinusHour.setHours(epMinusHour.getHours()-1);
    var epocHighlightShapes = [{
                                type: 'rect',
                                xref: 'x',
                                yref: 'paper',
                                x0: epMinusHour.toISOString(),
                                y0: 0,
                                x1: selectedEpoch.toISOString(),
                                y1: 1,
                                fillcolor: statusColor,
                                opacity: 0.5,
                                line: {
                                  width: 0
                                }}]

    useEffect(()=>{
         setDataLoadedFlag(false)
    },[airport])

    const [plotLayout,setPlotLayout] = useState({grid:{rows:3,columns:1,xside:'bottom plot',ygap:0.2},
                                                 xaxis:{anchor:'y',
                                                      sharedx:true,
                                                      hovermode:'x unified',
                                                      nticks:7,
                                                      range:[plotRangeStartLatest.toISOString(),
                                                            plotRangeEndLatest.toISOString()],
                                                      showlegend:false},
                                                  yaxis:{anchor:'x',zeroline:false,'title':{text:'Total Encroachment<br>Duration [s]',font:{size:12}}},
                                                  yaxis2:{anchor:'x2',zeroline:false,'title':{text:'Mean Centerine<br>Deviation [ft]',font:{size:12}}},
                                                  yaxis3:{anchor:'x3',zeroline:false,'title':{text:'GoAround Counts<br>per 15min',font:{size:12}}},
                                                  margin:{b:20,t:20},
                                                  hovermode:'x unified',
                                                  shapes:epocHighlightShapes,
                                                });

    const [overlayFlag, setOverlayFlag] = useState(false)
    var dateOptions = {month:'short',day:'numeric',
                       hour:'2-digit',minute:'2-digit',hour12:false}
    
    useEffect(()=>{
      var plotRangeStartLatest = new Date(selectedEpoch)
      var plotRangeEndLatest = new Date(selectedEpoch)
      plotRangeStartLatest.setHours(plotRangeStartLatest.getHours()-3)
      plotRangeEndLatest.setHours(plotRangeEndLatest.getHours()+2)
      setPlotRangeStart(plotRangeStart)
      setPlotRangeEnd(plotRangeEnd)
    },[selectedEpoch])
    useEffect(() =>{
      if(selectedEpochString !==renderedEpochString){
        setRenderedEpochString(selectedEpochString)
      }
    }, [renderedEpochString,latestEpochFlag,selectedEpochString,displayEpochString]);

    const promiseFetchData = (id) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(`Data for component ${id}`);
        }, Math.random() * 2000); // Random delay up to 2 seconds
      });
    };

    useEffect(() => {
        if(queryIterTime.getTime() >= metricStartTime.getTime()){
            setQueryChunkHours(queryChunkHours+0.5)
            var queryEndTime = queryIterTime
            var shiftedQueryIterTime = new Date(queryIterTime.getTime() - parseInt(queryChunkHours* 60*60*1000))
            var queryEndTimeComps = queryEndTime.toUTCString().split(/-| |:/)
            var queryEndTimeForAPIQuery = queryEndTimeComps[3]+queryEndTimeComps[2]+queryEndTimeComps[1]+queryEndTimeComps[4]+queryEndTimeComps[5]

            var queryStartTimeComps = shiftedQueryIterTime.toUTCString().split(/-| |:/)
            var queryStartTimeForAPIQuery = queryStartTimeComps[3]+queryStartTimeComps[2]+queryStartTimeComps[1]+queryStartTimeComps[4]+queryStartTimeComps[5]
            axios.post(backendApiPrefix+'/api/get-metrics-all/',{airport:airport,
                                                               epoch:selectedEpochString,
                                                              from:queryStartTimeForAPIQuery,to:queryEndTimeForAPIQuery})
            .then(response => {
              setDataLoadedFlag(true)
              // Defensive: a partial/empty/error-shaped response must not crash the
              // dashboard card (one bad airport shouldn't white-screen the summary).
              var jsonData = (response.data && response.data.message) || {}
              var encr = jsonData.metroplexEncroachmentData || {}
              var encrDur = encr.encrDur || {}
              var cld = jsonData.centerlineDevData || {}
              var goa = jsonData.goAroundCountData || {}
              var encrEpochs = encr.epochString || []
              setQueryIterTime(shiftedQueryIterTime)
              setMetroplexEncroachmentDataAll({...metroplexEncroachmentDataAll,
                epochString:[...encrEpochs,...metroplexEncroachmentDataAll.epochString],
                encrDur:{
                    Total:[...(encrDur.Total || []),...metroplexEncroachmentDataAll.encrDur.Total],
                    Adjusted:[...(encrDur.Adjusted || []),...metroplexEncroachmentDataAll.encrDur.Adjusted]
                  }})
              setCenterlineDeviationDataAll({...centerlineDeviationDataAll,
                                    epochString:[...(cld.epochString || []),
                                                  ...centerlineDeviationDataAll.epochString],
                                    meanCenterlineDeviation_mean:[...(cld.meanCenterlineDeviation_mean || []),
                                                                  ...centerlineDeviationDataAll.meanCenterlineDeviation_mean]})
              setGoAroundCountDataAll({...goAroundCountDataAll,
                                    epochString:[...(goa.epochString || []),
                                                  ...goAroundCountDataAll.epochString],
                                    goAround15min:[...(goa.goAround15min || []),
                                                    ...goAroundCountDataAll.goAround15min],
                                    holdingPattern15min:[...(goa.holdingPattern15min || []),
                                                          ...goAroundCountDataAll.holdingPattern15min]})

              if (encrEpochs.length > 0) {
                setPlotLayout({...plotLayout,
                  xaxis:{...plotLayout.xaxis,
                          range:[plotRangeStart.toISOString(), plotRangeEnd.toISOString()]
                  },
                  shapes:epocHighlightShapes})
              }
            })
          .catch(error => {
            console.log(error);
          });
        }
        else{

        }
    }, [queryIterTime]);   
    function resetMetricStates(){
      setQueryIterTime(new Date())
      setMetricStartTime(new Date(new Date().getTime() - metricLookBackHorizonDays* 24 * 60 * 60 * 1000))
      setMetroplexEncroachmentDataAll({epochString:[],encrDur:{Total:[],Adjusted:[]}}); 
      setCenterlineDeviationDataAll({epochString:[],meanCenterlineDeviation_mean:[]}); 
      setGoAroundCountDataAll({epochString:[],goAround15min:[],holdingPattern15min:[]}); 
    };
    useEffect(()=>{
      setTitle(overlayFlag?'Summary Snapshot - '+airport:'')
    },[overlayFlag])

    // useEffect(()=>{
    //   if(Object.hasOwn(metroplexEncroachmentDataAll,'encrDur')){
    //     setDataLoadedFlag(true)
    //   }
    // },[metroplexEncroachmentDataAll]);

    function handleOverlayClick(e){
        console.log(e.target)
        if(e.target.id === 'overlayPlot'){
            setOverlayFlag(false)
        }
    }
    
    
    
    // const DetailedSummaryOverlayDiv = ()=>{
    //     return(
            
    //         );
    // };
    
    const handleSummaryBoxClick = () =>{setOverlayFlag(true)}
    
    useEffect(()=>{
      var apiSuffix;
      if(latestEpochFlag){
        apiSuffix='latest';
      }else{
        apiSuffix=renderedEpochString;
      };
    Promise.all([
      axios.get(apiPrefix+'metroplex-buffer-encroachments?metroplex='+metroplex+'&duration='+apiSuffix),
      axios.get(apiPrefix+'centerline-deviations?airport='+airport+'&duration='+apiSuffix),
      axios.get(apiPrefix+'go-around-counts?airport='+airport+'&duration='+apiSuffix),
      axios.get(apiPrefix+'metroplex-buffer-encroachments/get-historic-encroachment-percentiles?metroplex='+metroplex)])
      .then(axios.spread((metroplexDataRes,centerlineDataRes,goAroundCountRes,encrDataPercentilesRes) => {
        var metroplexEncrDataTs = metroplexDataRes.data.epochTimestamp//[metroplexDataRes.data.epochTimestamp.length-1]
        var centerlineDevDataTs = centerlineDataRes.data.epochTimestamp//[centerlineDataRes.data.epochTimestamp.length-1]
        var goAroundCountsDataTs = goAroundCountRes.data.epochTimestamp//[goAroundCountRes.data.epochTimestamp.length-1]
        
        // const encrData50Perc = encrDataPercentilesRes.data['50Perc']
        // const encrData75Perc = encrDataPercentilesRes.data['75Perc']
        // const encrData80Perc = encrDataPercentilesRes.data['80Perc']
        // const encrData95Perc = encrDataPercentilesRes.data['95Perc']
        // const encrData99Perc = encrDataPercentilesRes.data['99Perc']
        var adjustedEncrDur = metroplexDataRes.data.encrDur.Total
        if(metroplexDataRes.data.MetCondition['K'+airport] === 'VMC'){
            adjustedEncrDur = metroplexDataRes.data.confDur.A.Total +
                              metroplexDataRes.data.confDur.B.Total
        }
        
        var ep = new Date(Math.min(...[metroplexEncrDataTs,centerlineDevDataTs,goAroundCountsDataTs])*1000)
        
        //console.log("res",metroplexDataRes.data.epochTimestamp[metroplexDataRes.data.epochString.length-1])
        // console.log(props.airport,metroplexDataRes.data.encrDur.Total)
        // console.log(props.airport,centerlineDataRes.data.meanCenterlineDeviation_mean)
        // console.log(props.airport,goAroundCountRes.data.goAround15min)
        setMetroplexEncroachmentDataSelected(metroplexDataRes.data.encrDur.Total);
        setAdjustedMetroplexEncroachmentDataSelected(adjustedEncrDur)
        setCenterlineDeviationDataSelected(centerlineDataRes.data.meanCenterlineDeviation_mean);
        setGoAroundCountDataSelected(goAroundCountRes.data.goAround15min);
        
        var boxColor;
        if(adjustedEncrDur > encrDataPercentilesRes.data[coloringThresholds['RED']]){
            boxColor = RED;
        }else if(adjustedEncrDur > encrDataPercentilesRes.data[coloringThresholds['ORANGE']]){
            boxColor = ORANGE;
        }else{
            boxColor = GREEN
        }
        setStatusColor(boxColor)
        for(var idx in epocHighlightShapes){
          epocHighlightShapes[idx]['fillcolor'] = boxColor
        }

        var plotRangeStartLatest = new Date(selectedEpoch)
        var plotRangeEndLatest = new Date(selectedEpoch)
        plotRangeStartLatest.setHours(plotRangeStartLatest.getHours()-3)
        plotRangeEndLatest.setHours(plotRangeEndLatest.getHours()+2)
        setPlotRangeStart(plotRangeStart)
        setPlotRangeEnd(plotRangeEnd)
        if(dataLoadedFlag){
          setPlotLayout({...plotLayout,
            xaxis:{...plotLayout.xaxis,
                  range:[plotRangeStartLatest.toISOString(),
                    Math.min([metroplexEncroachmentDataAll.epochString[metroplexEncroachmentDataAll.epochString.length-1],plotRangeEndLatest.toISOString()])]
              },
            shapes:epocHighlightShapes})
        };
      }))
      .catch(error => {
        console.log(error);
      });
      },[renderedEpochString,coloringThresholds])
        // useEffect(() => {
        // const interval = setInterval(() => {
          // updateData();
        // }, 2000);
        // return () => clearInterval(interval);
      // }, []);
    const handleDetailedSummaryClick=()=>{
      setActiveMetric('airport-summary')
      setActiveAirport(airport)
      setMetricSelectedIndex(summaryMetricIndex)
    }
    return(
    <>
    {/* <SummaryBoxDiv color={statusColor} onClick={handleSummaryBoxClick}> */}
    <SummaryBoxDiv color={statusColor} onClick={handleDetailedSummaryClick} as={Link} to={"/metrics/airport-summary/"+airport}>
        <AirportNameStyle>{airport}</AirportNameStyle>
        <DataBlockDiv>
            <p>
            Encroachment Dur.: {JSON.stringify(metroplexEncroachmentDataSelected)} [s]<br/> 
            Adjusted Encr. Dur.: {JSON.stringify(adjustedMetroplexEncroachmentDataSelected)} [s]<br/> 
            Mean Centerline Dev.: {JSON.stringify(centerlineDeviationDataSelected)} [ft]<br/>
            Go-around Counts: {JSON.stringify(goAroundCountDataSelected)}
            </p>
        </DataBlockDiv>
        <SelectedEpochDiv>Epoch: {displayEpochString}</SelectedEpochDiv>
    </SummaryBoxDiv>
    {overlayFlag &&
        <div style={{position:"fixed",zIndex:15}} >
        <DetailedSummaryOverlayDivStyle>
            <OverlayPlotDivStyle id="overlayPlot" onClick={handleOverlayClick}>
            <div style={{zIndex:3,width:'100vh',backgroundColor:'white',paddingBottom:'10px',position:"relative"}}>
              {!dataLoadedFlag&&<Box sx={{ display:'fixed',width:'100%',height:'100%',justifyContent:'flex-center',zIndex:3,position:"absolute",backgroundColor:'rgba(100,100,100,0.5)'}}>
              <CircularProgress style={{marginTop:'30vh'}}/>
            </Box>}
            <Plot  data={[{x:metroplexEncroachmentDataAll.epochString,
                y: metroplexEncroachmentDataAll.encrDur.Total,
                type: 'scatter',
                mode: 'lines',
                marker: {color: 'rgba(255,0,0,0.4)'},
                name:'Total Encroachment Duration',
                hovertemplate:'%{y}<extra>Total EncrDur [s]</extra>',
                showlegend:false,
                xaxis:'x',
                yaxis:'y',
              },
              {
                x: centerlineDeviationDataAll.epochString,
                y: centerlineDeviationDataAll.meanCenterlineDeviation_mean,
                type: 'scatter',
                mode: 'lines',
                marker: {color: 'rgba(0,0,255,0.4)'},
                name:'Centerline Deviation',
                hovertemplate:'%{y}<extra>Mean Deviation [ft]</extra>',
                showlegend:false,
                xaxis:'x',
                yaxis:'y2'
              },
              {
                x: goAroundCountDataAll.epochString,
                y: goAroundCountDataAll.goAround15min,
                type:'scatter',
                mode:'lines',
                marker: {color: 'rgba(0,255,0,0.4)'},
                name:'Go Around Counts',
                hovertemplate:'%{y}<extra>15 min counts</extra>',
                xaxis:'x',
                showlegend:false,
                yaxis:'y3'
              }
            ]}
            id="plotDiv"
            style={{display:'fixed',width:'100vh',height:'80vh'}}
            layout={plotLayout}
            config={{responsive:true}}
          />
            <div style={{width:'100vh',display:'flex',justifyContent:'flex-end',marginRight:'10px'}}>
              <Button style={{height:'32px',minWidth: '195px', maxWidth: '195px',marginRight:'10px'}} 
                variant="contained" onClick={handleDetailedSummaryClick} component={Link} to={"/metrics/airport-summary/"+airport}>Detailed Summary</Button>
            </div>
          </div>
          </OverlayPlotDivStyle>
        </DetailedSummaryOverlayDivStyle>
        </div>}
    </>
    );
    
    
};

export default SummaryBox